import React from "react";
import {
  Card,
  H1,
  H3,
  ControlGroup,
  Tag,
  HTMLSelect,
  Button,
  Spinner,
  NonIdealState,
  Text,
} from "@blueprintjs/core";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { apiCallPost } from "../../../micro/fns/util";
import cogoToast from "cogo-toast";
import _ from "lodash";
import moment from "moment";
import SurgeryCalendar from "../../components/calendar/SurgeryCalendar";
import SingleSelectWrapper from "../../../micro/utils/SingleSelectWrapper";
class SxCalendarBranchwise extends React.Component {
  state = {
    isLoadingMeta: false,
    branches: [],
    doctors: [],
    selectedBranch: null,
    selectedDoctor: null,
    calendarSelectedDate: null,
    // Search/multi-view state
    isSearching: false,
    multiCalendars: [], // [{ doctorId, doctorName }]
    selectedDateByDoctor: {},
  };

  componentDidMount() {
    this.loadBranches();
  }


  createBranchItems = () => {
    const branchItems = this.state.branches.map((branch) => branch.name).filter(Boolean);
    return ["Select Branch", ...branchItems];
  };

  getDoctorDisplayName = (doctor) => {
    if (!doctor) return "";
    const name = String(doctor.name || doctor.doctorName || "").trim();
    const shortcode = String(doctor.shortcode || doctor.shortCode || doctor.code || "").trim();
    if (shortcode && name) return `${shortcode} | ${name}`;
    if (name) return name;
    return shortcode;
  };

  // Helper function to create doctor items for searchable dropdown
  createDoctorItems = () => {
    const doctorItems = this.state.doctors
      .map((doctor) => this.getDoctorDisplayName(doctor))
      .filter((label) => label && label.length > 0);
    return ["Select Doctor", ...doctorItems];
  };

  // Handle branch selection from SingleSelectWrapper
  handleBranchSelect = (selectedBranchName) => {
    if (selectedBranchName === "Select Branch") {
      this.setState({ selectedBranch: null, selectedDoctor: null, multiCalendars: [], doctors: [] });
      return;
    }
    const branch = this.state.branches.find((b) => b.name === selectedBranchName);
    if (branch) {
      this.setState({ selectedBranch: branch, selectedDoctor: null, multiCalendars: [] }, () => {
        this.loadDoctors();
      });
    }
  };

  // Handle doctor selection from SingleSelectWrapper
  handleDoctorSelect = (selectedDoctorName) => {
    if (selectedDoctorName === "Select Doctor") {
      this.setState({ selectedDoctor: null });
      return;
    }
    const doctor = this.state.doctors.find(
      (d) => this.getDoctorDisplayName(d) === selectedDoctorName || d.name === selectedDoctorName
    );
    if (doctor) {
      this.setState({ selectedDoctor: doctor });
    }
  };

  loadBranches = async () => {
    try {
      this.setState({ isLoadingMeta: true });
      const response = await apiCallPost(`/rai/${this.props.authStore.prefix}/getAllSites`, {});
      const branches = (response || []).map((name, idx) => ({ _id: `branch_${idx}`, name }));
      this.setState({ branches, isLoadingMeta: false });
    } catch (err) {
      console.error("Failed to load branches", err);
      cogoToast.error("Failed to load branches");
      this.setState({ isLoadingMeta: false });
    }
  };

  loadDoctors = async () => {
    try {
      this.setState({ isLoadingMeta: true });
      const response = await apiCallPost(`/rai/${this.props.authStore.prefix}/getAllConsultants`, {});
      const doctors = (response || []).map((d, idx) => {
        if (typeof d === "string") {
          return { _id: `doc_${idx}`, name: d };
        }
        return {
          _id: d._id || `doc_${idx}`,
          name: d.name || d.doctorName || "",
          shortcode: d.shortcode || d.shortCode || d.code || "",
        };
      });
      this.setState({ doctors, isLoadingMeta: false });
    } catch (err) {
      console.error("Failed to load doctors", err);
      cogoToast.error("Failed to load doctors");
      this.setState({ isLoadingMeta: false });
    }
  };

  // handleBranchChange = async (e) => {
  //   const branchId = e.target.value;
  //   const branch = this.state.branches.find((b) => b._id === branchId) || null;
  //   this.setState({ selectedBranch: branch, selectedDoctor: null, multiCalendars: [] }, () => {
  //     this.loadDoctors();
  //   });
  // };

  // handleDoctorChange = (e) => {
  //   const doctorId = e.target.value;
  //   const doctor = this.state.doctors.find((d) => d._id === doctorId) || null;
  //   this.setState({ selectedDoctor: doctor });
  // };

  onSearch = async () => {
    const { selectedBranch, selectedDoctor } = this.state;

    if (!selectedBranch) {
      cogoToast.error("Please select a Branch first");
      return;
    }

    // If both branch and doctor are selected, single calendar already shows automatically
    if (selectedBranch && selectedDoctor) {
      this.setState({ multiCalendars: [] });
      return;
    }

    try {
      this.setState({ isSearching: true, multiCalendars: [] });

      const effectiveFrom = moment().startOf("day").format("YYYY-MM-DD");
      const effectiveTo = moment().add(3, "months").endOf("day").format("YYYY-MM-DD");

      const schedules = await apiCallPost(
        `/v3/${this.props.authStore.prefix}/neoSxDoctorScheduleMaster/getAll`,
        {
          branchName: selectedBranch.name,
          effectiveFrom,
          effectiveTo,
        }
      );

      const validSchedules = (schedules || []).filter((s) => (s?.surgeryCount || 0) > 0);
      const byDoctor = _.groupBy(validSchedules, (s) => s.doctorId || s.doctorName);
      const doctors = Object.keys(byDoctor).map((key) => {
        const first = byDoctor[key][0] || {};
        return {
          doctorId: first.doctorId || key,
          doctorName: first.doctorName || "Doctor",
        };
      });

      const uniqDoctors = _.uniqBy(doctors, (d) => d.doctorId);

      if (uniqDoctors.length === 0) {
        cogoToast.warn("No doctor calendars with available slots in the next 3 months");
      } else {
        cogoToast.success(`Found ${uniqDoctors.length} doctor(s) with schedules`);
      }

      this.setState({ multiCalendars: uniqDoctors });
    } catch (err) {
      console.error("Failed to search calendars:", err);
      cogoToast.error("Failed to search calendars");
    } finally {
      this.setState({ isSearching: false });
    }
  };

  handleSlotSelect = (slot) => {
    if (!this.state.selectedBranch || !this.state.selectedDoctor) return;
    const params = new URLSearchParams({
      branchId: this.state.selectedBranch._id,
      branchName: this.state.selectedBranch.name,
      doctorId: this.state.selectedDoctor._id,
      doctorName: this.state.selectedDoctor.name,
      date: moment(this.state.calendarSelectedDate).format("YYYY-MM-DD"),
      timeFrame: slot.timeFrame,
    });
    this.props.history.push(`/v3/workflow/surgery-booking?${params.toString()}`);
  };

  handleSlotSelectForDoctor = (doctor, slot) => {
    const { selectedBranch, selectedDateByDoctor } = this.state;
    if (!selectedBranch) return;
    const dateForDoctor = selectedDateByDoctor[doctor.doctorId] || this.state.calendarSelectedDate;
    if (!dateForDoctor) {
      cogoToast.error("Please select a date on the doctor's calendar first");
      return;
    }
    const params = new URLSearchParams({
      branchId: selectedBranch._id,
      branchName: selectedBranch.name,
      doctorId: doctor.doctorId,
      doctorName: doctor.doctorName,
      date: moment(dateForDoctor).format("YYYY-MM-DD"),
      timeFrame: slot.timeFrame,
    });
    this.props.history.push(`/v3/workflow/surgery-booking?${params.toString()}`);
  };

  renderHeader() {
    return (
      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
          <div>
            <H1 style={{ color: "var(--text-primary)", margin: 0 }}>Branchwise Surgery Calendar</H1>
            <p style={{ color: "var(--text-secondary)", margin: "5px 0" }}>
              Select a branch and drill down to a doctor to view monthly slot availability.
            </p>
          </div>
          <Button
            intent="primary"
            icon="add"
            large
            onClick={() => {
              const params = new URLSearchParams();
              if (this.state.selectedBranch) {
                params.set("branchId", this.state.selectedBranch._id);
                params.set("branchName", this.state.selectedBranch.name);
              }
              if (this.state.selectedDoctor) {
                params.set("doctorId", this.state.selectedDoctor._id);
                params.set("doctorName", this.state.selectedDoctor.name);
              }
              params.set("mode", "create");
              this.props.history.push(`/v3/workflow/surgery-booking?${params.toString()}`);
            }}
          >
            Create New Surgery
          </Button>
        </div>
      </div>
    );
  }

  renderFilters() {
    const { branches, doctors, selectedBranch, selectedDoctor, isLoadingMeta } = this.state;

    return (
      <Card className="v3-card" style={{ marginBottom: "20px" }}>
        <div className="v3-card-header">
          <H3 className="v3-card-title">Filters</H3>
        </div>
        <div className="v3-card-body" style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "center" }}>
          <ControlGroup>
            <Tag large minimal>Branch</Tag>
            {/* <HTMLSelect
              large
              value={selectedBranch?._id || ""}
              onChange={this.handleBranchChange}
              options={[{ value: "", label: "Select Branch" }, ...branches.map((b) => ({ value: b._id, label: b.name }))]}
              disabled={isLoadingMeta}
            /> */}
            <SingleSelectWrapper
              items={this.createBranchItems()}
              selectedItem={selectedBranch?.name || null}
              placeholder="Search and select branch..."
              onChange={this.handleBranchSelect}
              width="250px"
              noResultsText="No branches found"
              disabled={isLoadingMeta}
              inputProps={{
                large: true,
                leftIcon: "search",
              }}
            />
          </ControlGroup>

          <ControlGroup>
            <Tag large minimal>Doctor</Tag>
            {/* <HTMLSelect
              large
              value={selectedDoctor?._id || ""}
              onChange={this.handleDoctorChange}
              options={[
                { value: "", label: selectedBranch ? "Select Doctor" : "Select Branch First" },
                ...doctors.map((d) => ({ value: d._id, label: d.name })),
              ]}
              disabled={!selectedBranch || isLoadingMeta}
            /> */}

            <SingleSelectWrapper
              items={this.createDoctorItems()}
              selectedItem={this.getDoctorDisplayName(selectedDoctor) || null}
              placeholder={selectedBranch ? "Search and select doctor..." : "Select branch first"}
              onChange={this.handleDoctorSelect}
              width="250px"
              noResultsText="No doctors found"
              disabled={!selectedBranch || isLoadingMeta}
              inputProps={{
                large: true,
                leftIcon: "search",
              }}
            />
          </ControlGroup>

          <Button
            large
            intent="primary"
            icon="search"
            onClick={this.onSearch}
            disabled={isLoadingMeta || !selectedBranch}
            loading={this.state.isSearching}
          >
            Search
          </Button>
        </div>
      </Card>
    );
  }

  renderCalendar() {
    const { selectedBranch, selectedDoctor, multiCalendars, isSearching } = this.state;

    // Single large calendar when both selected
    if (selectedBranch && selectedDoctor) {
      return (
        <Card className="v3-card" style={{ padding: 16 }}>
          <SurgeryCalendar
            doctorId={selectedDoctor._id}
            branchId={selectedBranch._id}
            branchName={selectedBranch.name}
            onDateSelect={(date) => this.setState({ calendarSelectedDate: date })}
            onSlotSelect={(slot) => this.handleSlotSelect(slot)}
          />
        </Card>
      );
    }

    // Multi small calendars when only branch selected and search run
    if (selectedBranch && multiCalendars && multiCalendars.length > 0) {
      return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))", gap: 16 }}>
          {multiCalendars.map((doc) => (
            <Card key={doc.doctorId} className="v3-card" style={{ padding: 12 }}>
              <div className="v3-card-header" style={{ marginBottom: 8 }}>
                <H3 className="v3-card-title" style={{ margin: 0 }}>{doc.doctorName}</H3>
              </div>
              <div className="v3-card-body" style={{ transform: "scale(0.92)", transformOrigin: "top left" }}>
                <SurgeryCalendar
                  doctorId={doc.doctorId}
                  branchId={selectedBranch._id}
                  branchName={selectedBranch.name}
                  onDateSelect={(date) =>
                    this.setState((prev) => ({
                      selectedDateByDoctor: {
                        ...prev.selectedDateByDoctor,
                        [doc.doctorId]: date,
                      },
                    }))
                  }
                  onSlotSelect={(slot) => this.handleSlotSelectForDoctor(doc, slot)}
                />
              </div>
            </Card>
          ))}
        </div>
      );
    }

    return (
      <Card className="v3-card" style={{ padding: 16, textAlign: "center" }}>
        <Text className="v3-text-secondary">
          {selectedBranch
            ? isSearching
              ? "Searching calendars..."
              : "Select Doctor or click Search to view all doctors for this branch"
            : "Select Branch to begin"}
        </Text>
      </Card>
    );
  }

  render() {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "var(--bg-primary)",
          color: "var(--text-primary)",
          minHeight: "100vh",
        }}
      >
        {this.renderHeader()}
        {this.renderFilters()}
        {this.renderCalendar()}
      </div>
    );
  }
}

export default inject("authStore")(observer(withRouter(SxCalendarBranchwise)));


